import { render, staticRenderFns } from "./ArrowFoward.vue?vue&type=template&id=27f1ba48"
import script from "./ArrowFoward.vue?vue&type=script&lang=js"
export * from "./ArrowFoward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports